module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-16.14e1664e.png";